document.addEventListener('DOMContentLoaded', function () {
  function checkAuth() {
    let topBtnLogin = document.getElementById('top__btn_login')
    let topBtnReg = document.getElementById('top__btn_reg')
    let topBtnCabinet = document.getElementById('top__btn_cabinet')
    $.ajax({
      type: 'POST',
      url: '/cabinet/ajax/auth.php',
      dataType: 'json',
      error: function (jqXHR, textStatus, errorThrown) {
        console.log('errorThrown', errorThrown)
      },
      success: function (data) {
        if (data['authorized'] == 1) {
          location = '/cabinet/'
        }
      },
    })
  }
  //checkAuth();
  let mail__ja = document.getElementById('mail__ja')

  if (mail__ja) {
    mail__ja.innerHTML = localStorage.getItem('mail')
  }
  //dropdown
  function dropdownElem(item) {
    item.onclick = function (event) {
      item.classList.toggle('active')
    }
  }
  let dropdown__lang = document.getElementById('dropdown__lang')
  dropdownElem(dropdown__lang)

  //slider
  let slide = document.getElementsByClassName('slide')
  let slideIndex = 1
  let leftArrow = document.getElementById('left__arrow')
  let rightArrow = document.getElementById('right_arrow')
  //добавим точки
  let dotsBox = document.getElementById('dots__box')
  function slider() {
    function createDots(whatsDots) {
      for (let index = 0; index < whatsDots; index++) {
        let dots = document.createElement('div')
        dots.classList.add('dots')
        /*           if (index === 0) {
                    dots.classList.add('active');
               } */
        dotsBox.append(dots)
      }
    }
    function showSlides(n) {
      let dots = document.getElementsByClassName('dots')
      if (n < 1) {
        slideIndex = slide.length
      } else if (n > slide.length) {
        slideIndex = 1
      }
      for (let index = 0; index < slide.length; index++) {
        slide[index].style.display = 'none'
      }
      for (let index = 0; index < dots.length; index++) {
        dots[index].classList.remove('active')
      }
      slide[slideIndex - 1].style.display = 'flex'
      dots[slideIndex - 1].classList.add('active')
    }
    createDots(slide.length)
    showSlides(slideIndex)
    function plusSlide(n) {
      showSlides((slideIndex += n))
    }
    function currentSlide(n) {
      showSlides((slideIndex = n))
    }
    leftArrow.onclick = function () {
      plusSlide(-1)
    }
    rightArrow.onclick = function () {
      plusSlide(1)
    }
    dotsBox.onclick = function (e) {
      let dots = document.getElementsByClassName('dots')
      for (let index = 0; index < dots.length + 1; index++) {
        if (
          e.target.classList.contains('dots') &&
          e.target == dots[index - 1]
        ) {
          currentSlide(index)
        }
      }
    }
  }

  if (slide.length > 0) {
    slider()
  }
  //анимация input
  function inputAnime(animeClass) {
    let inputAnime = document.getElementsByClassName(animeClass)
    for (let index = 0; index < inputAnime.length; index++) {
      inputAnime[index].onfocus = function (e) {
        this.nextElementSibling.classList.add('active')
      }
      inputAnime[index].onblur = function (e) {
        if (!this.value) {
          this.nextElementSibling.classList.remove('active')
        }
      }
    }
    inputAnimeCheck('input__anime')
  }

  function inputAnimeCheck(animeClass) {
    let inputAnime = document.getElementsByClassName('input__anime')
    for (let index = 0; index < inputAnime.length; index++) {
      if (inputAnime[index].value) {
        inputAnime[index].nextElementSibling.classList.add('active')
      }
      if ($(inputAnime[index]).is(':-webkit-autofill')) {
        inputAnime[index].nextElementSibling.classList.add('active')
      }
    }
  }

  inputAnime('input__anime')

  //дата в футер
  document.getElementById('date__footer').innerHTML = new Date().getFullYear()
  //видео 1й блок
  function hoverVideo() {
    let videoHover = document.getElementsByClassName('video_hov')
    for (let index = 0; index < videoHover.length; index++) {
      const element = videoHover[index]
      element.onmouseover = function (event) {
        element.volume = 0
        element.play()
      }
      element.onmouseout = function (event) {
        element.pause()
      }
    }
  }
  hoverVideo()
  let videoPlayMain = document.getElementById('video__play')
  function robotVideo() {
    let videoRobot = document.getElementById('robot')
    let controlBox = document.getElementById('control__box')
    let play = document.getElementById('play')
    let pause = document.getElementById('pause')
    let stop = document.getElementById('stop')

    videoPlayMain.onclick = function (event) {
      videoRobot.play()
      videoPlayMain.style.display = 'none'
      controlBox.style.display = 'flex'
    }
    play.onclick = function (event) {
      videoRobot.play()
    }
    pause.onclick = function (event) {
      videoRobot.pause()
    }
    stop.onclick = function (event) {
      videoRobot.pause()
      videoRobot.currentTime = 0
      videoPlayMain.style.display = 'block'
      controlBox.style.display = 'none'
    }
  }
  if (videoPlayMain) {
    robotVideo()
  }
  window.onscroll = function navFix() {
    let nav = document.getElementById('header__fix')
    if (window.pageYOffset > 10) {
      nav.classList.add('nav__container__fix')
    } else {
      nav.classList.remove('nav__container__fix')
    }
  }

  let burger = document.getElementById('burger')
  let burgerMenuWrapp = document.getElementById('burger__menu__wrapp')
  let nav = document.getElementById('nav')

  burger.onclick = function (event) {
    this.classList.toggle('burger__active')
    burgerMenuWrapp.classList.toggle('active')
  }

  let btnReg = document.getElementById('js__reg')
  function registration() {
    let email_input = document.getElementById('email')
    let fio = document.getElementById('fio')
    let phone = document.getElementById('phone')
    let password = document.getElementById('password')
    let password2 = document.getElementById('password2')
    let rnd = document.getElementById('rnd')
    let oferta = document.getElementById('oferta')
    let politics = document.getElementById('politics')
    let lang = document.getElementById('lang__js').getAttribute('lang')
    let ofertaCheck = 0
    let politicsCheck = 0
    let valEmail = email.value
    if (oferta.checked) {
      ofertaCheck = 1
    }
    if (politics.checked) {
      politicsCheck = 1
    }
    $.ajax({
      type: 'POST',
      url: '/cabinet/ajax/register.php',
      dataType: 'json',
      data: {
        fio: fio.value,
        email: valEmail,
        phone: phone.value,
        password: password.value,
        password2: password2.value,
        rnd: rnd.value,
        oferta: ofertaCheck,
        politics: politicsCheck,
        lang: lang,
      },

      error: function (jqXHR, textStatus, errorThrown) {
        document.getElementById('js__reg').disabled = false
        document.getElementById('loader').style.display = 'none'
        console.log('errorThrown', errorThrown)
      },
      success: function (data) {
        if (data['result'] == 0) {
          document.getElementById('js__reg').disabled = false
          document.getElementById('loader').style.display = 'none'
          if (data['already_auth_err'] === 1) {
          }
          if (data['err_email']) {
            email_input.classList.add('error')
            document.getElementById('err-email').innerHTML = data['err_email']
            document.getElementById('err-email').style.display = 'block'
          }
          if (data['err_psw']) {
            password.classList.add('error')
            password2.classList.add('error')
            document.getElementById('err-password').innerHTML = data['err_psw']
            document.getElementById('err-password').style.display = 'block'
          }
          if (data['err_fio']) {
            fio.classList.add('error')
            document.getElementById('err-fio').innerHTML = data['err_fio']
            document.getElementById('err-fio').style.display = 'block'
          }
          if (data['err_phone']) {
            phone.classList.add('error')
            document.getElementById('err-phone').innerHTML = data['err_phone']
            document.getElementById('err-phone').style.display = 'block'
          }
          if (data['err_rnd']) {
            rnd.classList.add('error')
            document.getElementById('err-rnd').innerHTML = data['err_rnd']
            document.getElementById('err-rnd').style.display = 'block'
          }
          if (data['err_politics']) {
            document.getElementById('err-politics').innerHTML =
              data['err_politics']
            document.getElementById('err-politics').style.display = 'block'
          }
          if (data['err_oferta']) {
            document.getElementById('err-oferta').innerHTML = data['err_oferta']
            document.getElementById('err-oferta').style.display = 'block'
          }
          if (data['some_err']) {
            document.getElementById('err-some').innerHTML = data['some_err']
            document.getElementById('err-some').style.display = 'block'
          }
        }
        if (data['result'] == 1) {
          localStorage.setItem('mail', valEmail)
          location = '/registration_thanks'
        }
      },
    })
  }

  if (btnReg) {
    btnReg.onclick = function (event) {
      this.disabled = true
      document.getElementById('loader').style.display = 'block'
      event.preventDefault()

      $(
        '#err-email, #err-password, #err-fio, #err-phone, #err-rnd, #err-oferta, #err-politics, #err-some'
      ).html('')
      $('#email, #password, #password2, #fio, #phone, #rnd').removeClass(
        'error'
      )
      registration()
    }
  }

  function login() {
    let lang = document.getElementById('lang__js').getAttribute('lang')
    let login = document.getElementById('login')
    let password = document.getElementById('password')
    if (login.value.trim() == '' && password.value.trim() == '') {
      document.getElementById('err-all').style.display = 'block'
      return
    }
    $.ajax({
      type: 'POST',
      url: '/cabinet/ajax/auth.php',
      dataType: 'json',
      data: {
        login: login.value,
        password: password.value,
        lang: lang,
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log('errorThrown', errorThrown)
      },
      success: function (data) {
        // console.log('data', data)
        if (data['authorized'] == 0) {
          document.getElementById('err-auth').style.display = 'block'
        }
        if (data['authorized'] == 1) {
          location = '/cabinet/'
        }
      },
    })
  }
  let btnLogin = document.getElementById('js__login')
  if (btnLogin) {
    btnLogin.onclick = function (event) {
      event.preventDefault()
      document.getElementById('err-all').style.display = 'none'
      document.getElementById('err-auth').style.display = 'none'
      login()
    }
  }

  let presBtn = document.getElementById('pres__btn')
  if (presBtn) {
    presBtn.onclick = function (event) {
      let presName = document.getElementById('pres__name')
      let presPhone = document.getElementById('pres__phone')
      let presMail = document.getElementById('pres__mail')

      $('#pres__name, #pres__phone').removeClass('error')
      document.getElementById('pres__err-name').style.display = 'none'
      document.getElementById('pres__err-phone').style.display = 'none'
      document.getElementById('pres__err-all').style.display = 'none'
      // console.log('presMail', presMail.value)
      if (presName.value == '') {
        presName.classList.add('error')
        document.getElementById('pres__err-name').style.display = 'block'
      }
      if (presPhone.value == '') {
        presPhone.classList.add('error')
        document.getElementById('pres__err-phone').style.display = 'block'
      }
      if (presName.value != '' && presPhone.value != '') {
        $.ajax({
          type: 'GET',
          url: '/createTask',
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
          },
          data: {
            email: presMail.value,
            phone: presPhone.value,
            name: presName.value,
          },
          error: function (jqXHR, textStatus, errorThrown) {
            // console.log('createTask err', errorThrown)
            document.getElementById('pres__err-all').style.display = 'block'
          },
          success: function (data) {
            if (data === 'err_val') {
              document.getElementById('pres__err-name').style.display = 'block'
              document.getElementById('pres__err-phone').style.display = 'block'
              return
            }
            if (data === 'err_auth') {
              document.getElementById('pres__err-all').style.display = 'block'
              console.log('createTask ошибка авторизации')
              return
            }
            if (data === 'err_phone') {
              document.getElementById('pres__err-phone').style.display = 'block'
              return
            }
            if (JSON.parse(data)['result'] == 1) {
              document.getElementById('success_pres').style.display = 'block'
            }
          },
        })
      }
    }
  }
  let contactBtn = document.getElementById('send__msg')
  if (contactBtn) {
    contactBtn.onclick = function (event) {
      let contactName = document.getElementById('contact__name')
      let contactEmail = document.getElementById('contact__email')
      let contactMsg = document.getElementById('contact__msg')
      let captcha = document.getElementById('captcha')
      document.getElementById('err-contact__email').style.display = 'none'
      document.getElementById('err-contact__name').style.display = 'none'
      document.getElementById('err-contact__msg').style.display = 'none'
      document.getElementById('err-contact__captcha').style.display = 'none'
      document.getElementById('err-contact__captcha2').style.display = 'none'
      document.getElementById('error_pres').style.display = 'none'

      $('#contact__name, #contact__email, #contact__msg, #captcha').removeClass(
        'error'
      )
      //console.log('contactMsg', contactMsg);
      if (contactName.value == '') {
        contactName.classList.add('error')
        document.getElementById('err-contact__name').style.display = 'block'
      }
      if (contactEmail.value == '') {
        contactEmail.classList.add('error')
        document.getElementById('err-contact__email').style.display = 'block'
      }
      if (captcha.value == '') {
        captcha.classList.add('error')
        document.getElementById('err-contact__captcha').style.display = 'block'
      }
      if (contactMsg.value == '') {
        contactMsg.classList.add('error')
        document.getElementById('err-contact__msg').style.display = 'block'
      }
      if (
        contactName.value != '' &&
        contactEmail.value != '' &&
        contactMsg.value != ''
      ) {
        $.ajax({
          type: 'GET',
          url: '/createTaskContacts',
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
          },
          data: {
            email: contactEmail.value,
            name: contactName.value,
            msgText: contactMsg.value,
            captcha: captcha.value,
          },
          error: function (jqXHR, textStatus, errorThrown) {
            console.log('errorThrown_createTaskContacts', errorThrown)
          },
          success: function (data) {
            //console.log('data', data);
            if (data === 'err_val') {
              contactName.classList.add('error')
              document.getElementById('err-contact__name').style.display =
                'block'
              contactEmail.classList.add('error')
              document.getElementById('err-contact__email').style.display =
                'block'
              captcha.classList.add('error')
              document.getElementById('err-contact__captcha').style.display =
                'block'
              contactMsg.classList.add('error')
              document.getElementById('err-contact__msg').style.display =
                'block'
              reloadCaptcha('captcha__img')
              return
            }
            if (data === 'err_rnd') {
              captcha.classList.add('error')
              document.getElementById('err-contact__captcha2').style.display =
                'block'
              reloadCaptcha('captcha__img')
              return
            }
            if (data === 'err_auth') {
              document.getElementById('error_pres').style.display = 'block'
              reloadCaptcha('captcha__img')
              console.log('createTaskContacts: err_auth')
              return
            }
            if (JSON.parse(data)['result'] == 1) {
              localStorage.setItem(
                'c-form',
                JSON.stringify({
                  email: contactEmail.value,
                  name: contactName.value,
                })
              )
              contactMsg.value = ''
              captcha.value = ''
              document.getElementById('err-contact__captcha2').style.display =
                'none'
              reloadCaptcha('captcha__img')
              document.getElementById('success_pres').style.display = 'block'
              $(
                '#contact__name, #contact__email, #contact__msg, #captcha'
              ).removeClass('error')
            } else {
              document.getElementById('error_pres').style.display = 'block'
              reloadCaptcha('captcha__img')
              console.log('createTaskContacts: err')
              return
            }
            reloadCaptcha('captcha__img')
          },
        })
      }
    }
  }

  if (JSON.parse(localStorage.getItem('c-form'))) {
    let contactName = document.getElementById('contact__name')
    if (contactName) {
      contactName.value = JSON.parse(localStorage.getItem('c-form'))['email']
    }
    let contactEmail = document.getElementById('contact__email')
    if (contactEmail) {
      contactEmail.value = JSON.parse(localStorage.getItem('c-form'))['name']
    }
  }
  function reloadCaptcha(captchaNode) {
    $.ajax({
      type: 'GET',
      url: '/reload-captcha',
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
      },
      success: function (data) {
        let thisCaptcha = document.getElementById(captchaNode)
        if (thisCaptcha) {
          thisCaptcha.innerHTML = data.captcha
        }
      },
    })
  }
  let reloadCaptchaBtn = document.getElementById('reload__captcha')
  if (reloadCaptchaBtn) {
    reloadCaptchaBtn.onclick = function (event) {
      reloadCaptcha('captcha__img')
    }
  }
  inputAnimeCheck('input__anime')

  setTimeout(inputAnimeCheck, 1000) //
  reloadCaptcha('captcha__img')
  /*  if(document.location.pathname == '/ww'){
     console.log(document.querySelector('.page__wrapp'));
     document.querySelector('.page__wrapp').classList.add('color');
 } */

  //  плеер гимна

  function hymnPlayerInit() {
    const playBtn = document.getElementById('hymn-play')
    const pauseBtn = document.getElementById('hymn-pause')
    const stopBtn = document.getElementById('hymn-stop')
    const currentTimeDisplay = document.getElementById('hymn-current-time')
    const audio = document.getElementById('hymn-audio-player')
    const progress = document.getElementById('player-progress')
    const progressContainer = document.getElementById(
      'player-progress-container'
    )

    if (
      !playBtn ||
      !pauseBtn ||
      !stopBtn ||
      !currentTimeDisplay ||
      !progressContainer ||
      !progress ||
      !audio
    ) {
      console.log('Ошибка плеера')
      return
    }
    // audio.addEventListener('canplaythrough', () => {
    //   console.log('Аудио загружено и готово к воспроизведению без остановок.')
    // })
    // function setProgress(e) {
    //   console.log('setProgress', audio.readyState)
    //   if (audio.readyState === 4) {
    //     const w = progressContainer.clientWidth // Ширина контейнера
    //     const x = e.offsetX // Положение клика
    //     const d = audio.duration // Продолжительность аудио
    //     // 223.104
    //     // Вычисление нового времени на основе позиции клика
    //     const newTime = (x / w) * d
    //     // audio.pause()
    //     audio.currentTime = newTime // Установка нового времени
    //     // audio.play()
    //     currentTimeDisplay.textContent = formatTime(newTime)
    //     // console.log('newTime', audio.readyState)
    //   }
    // }

    function formatTime(seconds) {
      const minutes = Math.floor(seconds / 60)
      const secs = Math.floor(seconds % 60)
      return `${minutes
        .toString()
        .padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
    }
    function play() {
      audio.play()
    }
    function pause() {
      audio.pause()
    }
    function stop() {
      audio.pause()
      audio.currentTime = 0
      currentTimeDisplay.textContent = '00:00'
    }
    playBtn.addEventListener('click', play)
    pauseBtn.addEventListener('click', pause)
    stopBtn.addEventListener('click', stop)

    function updateProgress(e) {
      const { duration, currentTime } = e.srcElement

      const progressPercent = (currentTime / duration) * 100
      progress.style.width = `${progressPercent}%`
      currentTimeDisplay.textContent = formatTime(audio.currentTime)
    }
    audio.addEventListener('timeupdate', updateProgress)
  }

  hymnPlayerInit()
}) //загрузка страницы
